import React from "react";
import PropTypes from "prop-types";
import { MasterSidebar } from "../../../../components/Common";
import { GLOBAL_STATUS } from "../../../../constants/common";

/**
 * PortfolioSidebar
 * Lista lateral de Colaboradores no layout Master-Detail.
 * Ao selecionar um employee, o painel detail exibe os clientes dele.
 */
const PortfolioSidebar = ({
    employees,
    activeId,
    onSelect,
    loading
}) => {

    const renderEmployeeItem = (employee, isActive) => (
        <div className="d-flex align-items-center w-100 overflow-hidden">
            <div className="avatar-xs flex-shrink-0 me-3 rounded-circle shadow-sm">
                {employee.photoUrl ? (
                    <img
                        src={employee.photoUrl}
                        alt={employee.fullName}
                        className="img-fluid rounded-circle w-100 h-100"
                        style={{ objectFit: 'cover' }}
                    />
                ) : (
                    <span className="avatar-title rounded-circle bg-light-soft text-primary font-size-18">
                        {employee.fullName ? employee.fullName.charAt(0).toUpperCase() : <i className="mdi mdi-account"></i>}
                    </span>
                )}
            </div>
            <div className="text-start flex-grow-1 overflow-hidden">
                <div className="d-flex align-items-center justify-content-between">
                    <p className={`mb-0 fw-semibold text-truncate ${isActive ? 'text-primary' : 'text-dark'}`} style={{ fontSize: '13.5px' }}>
                        {employee.fullName || `${employee.firstName || ""} ${employee.lastName || ""}`.trim() || employee.email}
                    </p>
                    {employee.status === GLOBAL_STATUS.INACTIVE && (
                        <i className="mdi mdi-eye-off-outline text-muted" style={{ fontSize: '14px' }} title="Inativo"></i>
                    )}
                </div>
                <span className="text-muted small text-truncate d-block mt-1" style={{ fontSize: '11px', opacity: 0.8 }}>
                    {employee.roleName || employee.role || "Colaborador"}
                </span>
            </div>
        </div>
    );

    return (
        <MasterSidebar
            title="Colaboradores"
            subtitle={`${employees.length} colaboradores`}
            items={employees}
            activeId={activeId}
            onSelect={onSelect}
            loading={loading}
            searchPlaceholder="Buscar colaborador..."
            icon="mdi mdi-account-group-outline"
            renderItem={renderEmployeeItem}
            loadingMessage="Carregando carteiras..."
        />
    );
};

PortfolioSidebar.propTypes = {
    employees: PropTypes.array.isRequired,
    activeId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    loading: PropTypes.bool
};

export default PortfolioSidebar;
